import { Intent } from "@blueprintjs/core";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import HeadingView from "common/views/heading/Heading.view";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import TypographyView from "common/views/typographyView/Typography.view";
import { IDataFragment } from "core/components/FragmentProvider";
import LabelProvider from "core/components/label/LabelProvider";
import { lastItem } from "core/util/ArrayUtil";
import { IBreadcrumb } from "core/util/IBreadcrumb";
import UrlUtil from "core/util/UrlUtil";
import CatalogLabels from "panels/catalog/Catalog.labels";
import { CatalogToaster } from "panels/catalog/catalogActions";
import CourseItem from "panels/catalog/entities/CourseItem";


export interface ICourseItemDisplayProps {
	courseItem: CourseItem;
}

// title
export const title: IDataFragment<ICourseItemDisplayProps> = {
	name: "Title",
	label: {k: "course.item.title", v: "Title"},
	component: ({courseItem}) => {
		return (
			<HeadingView viewKey="course.item.title">
				{courseItem && courseItem.title}
			</HeadingView>
		);
	}
};

// description
// export const description: IDataFragment<ICourseItemDisplayProps> = {
// 	name: "Description",
// 	label: {k: "course.item.description", v: "Description"},
// 	component: ({courseItem}) => {
// 		return (
// 		<div className="html-default">
// 			<TypographyView viewKey="course.item.description" html={courseItem && courseItem.description} />
// 		</div>
// 		);
// 	}
// };

// image
export const icon: IDataFragment<ICourseItemDisplayProps> = {
	name: "Static Icon",
	label: {k: "course.icon", v: "Icon"},
	component: ({courseItem}) => (
		
			<ImageView
				style={{
					display: 'block',
					maxWidth: '100%',
					width: '100%'
				}}
				src={courseItem && courseItem.iconUrl}
				variant={ImageVariant.THUMBNAIL}
				viewKey="course.item.image.static"
				overlay={
					courseItem &&
					courseItem.iconUrl && {
						src: courseItem.iconUrl,
						position: "top left",
					}
				}
			/>
		)
	
};

export const detailsButton: IDataFragment<ICourseItemDisplayProps> = {
	name: "Course Item Details Button",
	label: { k: "course.item.detailsButton", v: "Details" },
	component: ({ courseItem }) => {
			return (
				<PageLinkView
					attrs={
						courseItem && {
							"data-wap_ref": `${courseItem.title}`
						}
					}
					params={{
						entryId: courseItem && courseItem.entryId,
					}}
					viewKey="catalog.item.detailsLink"
					breadcrumbs={(target, breadcrumbs) => {
						let nextCrumbs: IBreadcrumb[] = [];
						const courseItemKey = "courseItem:" + courseItem.entryId;
						// push current page's crumb
						const lastCrumb = lastItem(breadcrumbs);

						const currentPath = UrlUtil.getCurrentPath();
						// if last crumb was for the current page and has a target, use that one
						if (
							lastCrumb &&
							lastCrumb.target.pathname === currentPath
						) {
							nextCrumbs = [
								...breadcrumbs.slice(0, breadcrumbs.length - 1),
								{
									...lastCrumb,
									target: {
										pathname: currentPath,
										search: UrlUtil.getSearch()
									}
								}
							];
						} else if (
							// if last crumb was for the current page and has no target path associated
							lastCrumb &&
							lastCrumb.target.pathname === ""
						) {
							nextCrumbs = [
								...breadcrumbs.slice(0, breadcrumbs.length - 1),
								{
									...lastCrumb,
									target: {
										pathname: currentPath,
										search: UrlUtil.getSearch()
									}
								}
							];
						} else {
							// else create a new one for the current page
							nextCrumbs = [
								...breadcrumbs,
								{
									key: "course-detail",
									label: {
										k: courseItemKey,
										v:
											window.parent.location.pathname.slice(
												1
											) || "Home"
									},
									target: {
										pathname: currentPath,
										search: UrlUtil.getSearch()
									}
								}
							];
						}

						// push article crumb
						nextCrumbs.push({
							key: courseItemKey,
							label: {
								k: courseItemKey,
								v: courseItem.title
							},
							//target
							target: {
								pathname: "",
								search: ""
							}
						});

						return nextCrumbs;
					}}
				>
					<ButtonView
						variant={ButtonVariant.PRIMARY}
						viewKey="catalog.item.detailsButton"
					>
						<CatalogLabels.Labels.ViewDetails />
					</ButtonView>
				</PageLinkView>
			);
	}
		//return null;
};
//}


// launch course / primary action
export const launchCourseItem: IDataFragment<ICourseItemDisplayProps> = {
	name: "Launch Course",
	label: { k: "course.item.launchCourse", v: "Launch" },
	component: ({courseItem}) => {

		// launchable
		if (courseItem.launchUrl) {
			return (
				<ButtonView
					variant={ButtonVariant.PRIMARY}
					viewKey="catalog.item.launchCourse"
					onClick={() => {
						window.open(courseItem.launchUrl,'launchwin');
						CatalogToaster.show({
							intent: Intent.PRIMARY,
							message: "Course launched in new tab"
						});
						return;
					} }
				>
					<CatalogLabels.Labels.LaunchCourseItem />
				</ButtonView>
			);
		}


		return null;
	}
};


// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/courseItem/displayFragments.tsx